(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/game-guide.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/game-guide.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.GameGuide = Marionette.View.extend({
    template: function() {
      return ''; 
    },

    initialize: function() {
      this.initTabViews();
    },

    initTabViews: function() {
      var className = 'padding-1';

      this.tabViews = [];

      this.tabViews.push({
        id: 'about',
        caption: 'Om Oddset Matchen',
        view: new Marionette.View({
          template: function(data) {
            return svs.matchen.templates.about(data);
          },
          className: className
        })
      });

      this.tabViews.push({
        id: 'howto',
        caption: 'Så här spelar du',
        view: new Marionette.View({
          template: function(data) {
            return svs.matchen.templates.howto(data);
          },
          className: className
        })
      });

      this.tabViews.push({
        id: 'winplan',
        caption: 'Vinstplan',
        view: new Marionette.View({
          template: function(data) {
            return svs.matchen.templates.winplan(data);
          },
          className: className
        })
      });
    },

    onRender: function() {
      var self = this;

      this.tabView = new svs.components.Tabs({
        el: this.el,
        tabs: this.tabViews,
        selected: this.getTabIdFromUrl(this.options.selectedTab)
      });

      this.tabView.on('onChange', function() {
        self.trigger('modalContentResize');
      });
    },

    onClose: function() {
      this.onDestroy();
    },

    onDestroy: function() {
      this.destroyTabView();
    },

    destroyTabView: function() {
      if (this.tabView) {
        this.tabView.destroy();
        this.tabView = null;
        this.tabViews = null;
      }
    },

    getTabIdFromUrl: function(tab) {
      switch (tab) {
        case '':
          return 'about';
        case 'sa-har-spelar-du':
          return 'howto';
        case 'vinstplan':
          return 'winplan';
        default:
          return '';
      }
    }
  });
})(Backbone, _, svs);


 })(window);